export default function EditIcon({
  width = 16,
  height = 17,
  color = "#AEADAF",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.75 2.49995C2.67893 2.49995 1 4.17888 1 6.24995V11.7499C1 13.821 2.67893 15.4999 4.75 15.4999H10.2501C12.3212 15.4999 14.0001 13.821 14.0001 11.7499V8.49995C14.0001 8.08574 13.6643 7.74995 13.2501 7.74995C12.8359 7.74995 12.5001 8.08574 12.5001 8.49995V11.7499C12.5001 12.9926 11.4927 13.9999 10.2501 13.9999H4.75C3.50736 13.9999 2.5 12.9926 2.5 11.7499V6.24995C2.5 5.00731 3.50736 3.99995 4.75 3.99995H7C7.41421 3.99995 7.75 3.66416 7.75 3.24995C7.75 2.83574 7.41421 2.49995 7 2.49995H4.75Z"
        fill={color}
      />
      <path
        d="M12.1339 5.69449L10.7197 4.28028L6.52812 8.47184C5.77185 9.22811 5.25635 10.1913 5.0466 11.2401C5.03144 11.3159 5.09828 11.3827 5.17409 11.3676C6.22285 11.1578 7.18606 10.6423 7.94233 9.88606L12.1339 5.69449Z"
        fill={color}
      />
      <path
        d="M13.4559 1.95667C13.2663 1.89344 13.0571 1.94281 12.9158 2.08419L11.7803 3.21962L13.1945 4.63383L14.33 3.4984C14.4714 3.35702 14.5207 3.1479 14.4575 2.95822C14.2999 2.48535 13.9288 2.11429 13.4559 1.95667Z"
        fill={color}
      />
    </svg>
  );
}
